import { setTuneCoreFailureDialog } from 'app/store/Releases/slice';
import { ChakraConfirmationDialog } from 'app/components/Dialogs/ChakraConfirmationDialog';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getTuneCoreFailureDialog } from 'app/store/Releases/selectors';
import { useDisclosure } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';

export const TuneCoreExportFailureDialog = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tuneCoreFailure = useAppSelector(getTuneCoreFailureDialog);
  const { isOpen, onClose } = useDisclosure({
    isOpen: Boolean(tuneCoreFailure),
  });

  const handleExportRedirect = () => {
    dispatch(setTuneCoreFailureDialog(undefined));
    navigate(routes.release.path.replace(':guid', tuneCoreFailure?.guid || ''));
  };

  return (
    <>
      {isOpen && (
        <ChakraConfirmationDialog
          size="md"
          isOpen={isOpen}
          onClose={onClose}
          onCloseComplete={() => {
            dispatch(setTuneCoreFailureDialog(undefined));
          }}
          handleAction={handleExportRedirect}
          title="Export Failed"
          message="Please try again."
          hideCancelButton
          actionButtonText="Go to Export"
        />
      )}
    </>
  );
};
